import { Asset } from '@websrc/App/Components/Asset/Asset'
import { CopyToClipboard } from '@websrc/App/Components/CopyToClipboard'
import { LessonSelector } from '@websrc/App/Components/Lesson/LessonSelector'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { mapTextAsset } from '@websrc/DataMappers/mapTextAsset'
import { Selector } from '@websrc/Spot/Selector/Selector'
import clsx from 'clsx'
import { box, breakpoints, styles, typography } from 'leds'
import React, { Fragment } from 'react'
import { match } from 'ts-pattern'

export type TextAssetProps = {
  data: ReturnType<typeof mapTextAsset>
  useBoxTypeText?: boolean
}

export const TextAsset = ({ data, useBoxTypeText }: TextAssetProps) => {
  const t = useStaticText()
  const contentSeparator = styles({ marginTop: { secondChild: 25, screenXS: 30 }, marginBottom: 0 })

  return (
    <div className={box({ align: 'center', type: useBoxTypeText ? 'text' : undefined })}>
      <h2
        className={clsx(
          typography({ responsiveSize: 'xl', weight: 'bold' }),
          styles({ display: 'flex', alignItems: 'center' })
        )}
        id={data.label}
      >
        {data.label}
        <CopyToClipboard id={data.label} tooltipText={t.print_and_share.copy_direct_link} />
      </h2>
      {data.content.map((contents, key) => (
        <Fragment key={key}>
          {match(contents)
            .with({ __dataType: 'asset' }, (asset) => (
              <Asset
                {...asset}
                className={contentSeparator}
                sizes={`(max-width: ${breakpoints.m}px) 90vw, 550px`}
                srcSetWidths={[400, 600, 800]}
              />
            ))
            .with({ __dataType: 'markdown' }, ({ content }) => (
              <Markdown className={contentSeparator} markdown={content} />
            ))
            .with({ __dataType: 'selector' }, (selector) => (
              <Selector
                className={styles({
                  marginTop: { secondChild: 25, screenXS: 48 },
                  marginBottom: 0,
                })}
                selector={selector}
              />
            ))
            .with({ __dataType: 'lessonSelector' }, (lessonSelector) => (
              <LessonSelector className={contentSeparator} selector={lessonSelector} />
            ))
            .otherwise(() => null)}
        </Fragment>
      ))}
    </div>
  )
}
